import Vue from 'vue';
import _ from 'lodash';
import {LA_SEARCH_DISPLAY} from '@/utils/listHubAPI'

import {
  FILTERS_SCHEME_SET,
  FILTERS_LISTINGS_SET,
} from '../mutations-types'

import {propertyTypes, counties} from '@/utils/filtersCommon'

const state = {
  filtersScheme: null,
  listings: [],
  filtersMeta: null
};

const getters = {
  filtersScheme: state => state.filtersScheme,
  listings: state => state.listings,
  filtersMeta: state => state.filtersMeta,
};


const actions = {
  /**
   * @URLParams
   * none
   * @BodyParams
   * none
   * **/
  FILTERS_SCHEME_REQUEST_GET ({ state, commit }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get('filters').then((response) => {
        commit(FILTERS_SCHEME_SET, response.data)
        resolve();
      }).catch(error => {
        reject(error);
      });
    });
  },

  /**
   * @URLParams
   * search:           string
   * county:           string
   *
   * price_min:        float
   * price_max:        float
   * year_min:         integer
   * year_max:         integer
   * lot_size_min:     float
   * lot_size_max:     float
   * square_feet_min:  float
   * square_feet_max:  float
   * bath_min:         integer
   * bath_max:         integer
   * bed_min:          integer
   * bed_max:          integer
   * property_type:    string
   * school:           string
   *
   * open_houses:      integer
   * virtual_tours:    integer
   * foreclosures:     integer
   * new_construction: integer
   * pending_sales:    integer
   * pending_sales:    integer
   *
   * page:             integer, required
   * per_page:         integer, required
   * @BodyParams
   * none
   * **/
  FILTERS_LISTINGS_REQUEST_GET ({ state, commit }, {filters, perPage}) {
    let requestData = _.assign({}, filters, {
      page: filters.page ? filters.page : 1,
      per_page: perPage
    });
    return new Promise((resolve, reject) => {
      Vue.axios.get('listings', {params: requestData})
        .then((response) => {
          commit(FILTERS_LISTINGS_SET, response.data)
          resolve();
        }).catch(error => {
        reject();
      });
    });
  },
};

const mutations = {
  [FILTERS_SCHEME_SET](state, data) {
    //---add county filter in te template
    data.push({
      max: '',
      min: '',
      name: 'county',
      type: 'select',
      values: counties
    })

    //---NOTE:  value = [null] | select = [null] | range = [null,null]  | multiselect = []
    let selectRangeNames = ['bed', 'bath'];

    data.forEach( filter => {
      if (filter.type === 'range' ) {
        filter.values = [];
        filter.values.push(null);
        filter.values.push(null);
        filter._dec = {
          selectRange: [],
          isErrorMin: false,
          isErrorMax: false
        };

        filter._dec.selectRange.push(null);
        filter._dec.selectRange.push(null);

        //--- selectRanges
        if (selectRangeNames.indexOf(filter.name) > -1) {
          let min = parseInt(filter.min),
            max = parseInt(filter.max);
          filter._dec.selectRange = [];

          for(min; min <= max; min++ ) {
            filter._dec.selectRange.push(min)
          }
        }
      } else if (filter.type === 'multiselect'){
        let undecoratedValues = _.cloneDeep(filter.values);
        filter.values = [];
        filter._dec = {
          multiselectRange: [],
          isError: false
        };

        for (let key in undecoratedValues) {
          let propertyTypeIcon = propertyTypes[key] ? propertyTypes[key].icon : propertyTypes['Other'].icon;
          let item = {
                value: undecoratedValues[key],
                icon: propertyTypeIcon
              }
          filter._dec.multiselectRange.push(item);
        }
      } else if (filter.type === 'select'){
        let undecoratedValues = _.cloneDeep(filter.values);
        filter.values = [];
        filter.values.push(null);
        filter._dec = {
          selectRange: [],
          isError: false,
          collection: undecoratedValues
        };
        for (let key in undecoratedValues) {
          filter._dec.selectRange.push({
            value: undecoratedValues[key]
          });
        }
      } else {
        filter.values = [];
        filter.values.push(null);
        filter._dec = {
          isError: false
        };
      }
    });

    Vue.set(state, 'filtersScheme', data);
  },

  [FILTERS_LISTINGS_SET](state, listings) {
    //---set info for LA
    if(listings.data && listings.data.length > 0) {
      let keysArray = [];
      listings.data.forEach(listing => {
        keysArray.push(listing.ListingKey)
      });
      LA_SEARCH_DISPLAY(keysArray);
    }

    Vue.set(state, 'listings', listings.data);
    Vue.set(state, 'filtersMeta', listings.meta);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
